<div class="content">
  <div class="content-panel">
    <h2 translate>page.declarations.suivi-parcellaires-viticoles.title</h2>
<form
  [formGroup]="searchForm"
  #form="ngForm"
  *ngIf="searchForm"
  (ngSubmit)="search()"
  novalidate
  class="search-form"
>
  <div class="card shadow-sm border-0 mb-3">
    <div class="card-body py-3">
      <div class="row g-3 align-items-end">

        <div class="col-12 col-lg-4">
          <label class="form-label" translate>
            page.declarations.suivi-parcellaires-viticoles.list.typeParcellaire
          </label>
          <select
            formControlName="suivi"
            (change)="changeType()"
            class="form-select"
            [ngClass]="{'is-invalid': form.submitted && searchForm.get('suivi')?.invalid}"
          >
            <option value="false">Parcellaire courant</option>
            <option value="true">Parcellaire affecté</option>
          </select>
        </div>

        <div class="col-12 col-lg-4" *ngIf="estAffecte">
          <label class="form-label" translate>
            page.declarations.suivi-parcellaires-viticoles.list.annee
          </label>
          <input
            type="number"
            lang="en"
            formControlName="annee"
            class="form-control"
            [ngClass]="{'is-invalid': form.submitted && searchForm.get('annee')?.invalid}"
          />
        </div>

        <div class="col-12 col-lg-4">
          <label class="form-label" translate>
            page.declarations.suivi-parcellaires-viticoles.list.raisonSociale
          </label>
          <input
            type="text"
            lang="en"
            formControlName="raisonSociale"
            class="form-control"
          />
        </div>

        <div class="col-12 col-lg-4 d-flex gap-2">
          <button
            type="button"
            class="btn btn-outline-secondary w-100"
            (click)="showAdvancedFilters = !showAdvancedFilters"
          >
            {{ showAdvancedFilters ? 'Masquer les filtres' : 'Filtres avancés' }}
          </button>

          <button type="submit" class="btn btn-primary w-100" translate>
            label.filtrer
          </button>

          <button
            type="button"
            *ngIf="historiques?.length > 0"
            (click)="exporterParcellaire()"
            class="btn btn-outline-primary w-100"
            translate
          >
            label.exporter
          </button>
        </div>
      </div>

      <div class="active-filters mt-3" *ngIf="hasActiveFiltersParcellaire()">

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="suiviLibelle">
          Type : {{ suiviLibelle }}
          <button type="button" class="chip-close" (click)="clearParcellaireField('suivi')">×</button>
        </span>

        <span
          class="badge text-bg-light border me-2 mb-2"
          *ngIf="estAffecte && searchForm.get('annee')?.value"
        >
          Année : {{ searchForm.get('annee')?.value }}
          <button type="button" class="chip-close" (click)="clearParcellaireField('annee')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="searchForm.get('raisonSociale')?.value">
          Raison sociale : {{ searchForm.get('raisonSociale')?.value }}
          <button type="button" class="chip-close" (click)="clearParcellaireField('raisonSociale')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="searchForm.get('cdcs')?.value?.length">
          CDC : {{ getLibelles(searchForm.get('cdcs')?.value, 'libelle') }}
          <button type="button" class="chip-close" (click)="clearParcellaireField('cdcs')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="searchForm.get('debutDate')?.value">
          Date début renseignée
          <button type="button" class="chip-close" (click)="clearParcellaireField('debutDate')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="searchForm.get('finDate')?.value">
          Date fin renseignée
          <button type="button" class="chip-close" (click)="clearParcellaireField('finDate')">×</button>
        </span>

        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          (click)="resetSearchForm()"
        >
          Tout effacer
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="showAdvancedFilters">
    <div class="card shadow-sm border-0 mb-3">
      <div class="card-body py-3">
        <div class="row g-3">

          <div class="col-12 col-md-6 col-xl-4">
            <label class="form-label" for="cdcs" translate>
              page.edition.generation-documents.exporter-declarations.form.cdcs
            </label>
            <app-multiselect
              id="cdcs"
              controlName="cdcs"
              [items]="refCahiers"
              bindLabel="libelle"
              maxWidth="initial"
              maxSelectedItems="4">
            </app-multiselect>
          </div>

          <div class="col-12 col-md-6 col-xl-4">
            <label for="debutDate" class="form-label" translate>
              page.declarations.suivi-parcellaires-viticoles.list.dateEntre
            </label>
            <div class="input-group">
              <input
                id="debutDate"
                ngbDatepicker
                #debutDatepicker="ngbDatepicker"
                formControlName="debutDate"
                class="form-control"
              />
              <button type="button" (click)="debutDatepicker.toggle()" class="btn btn-outline-secondary">
                <fa-icon icon="calendar-alt"></fa-icon>
              </button>
            </div>
          </div>

          <div class="col-12 col-md-6 col-xl-4">
            <label for="finDate" class="form-label" translate>
              page.declarations.suivi-parcellaires-viticoles.list.et
            </label>
            <div class="input-group">
              <input
                id="finDate"
                ngbDatepicker
                #finDatepicker="ngbDatepicker"
                formControlName="finDate"
                class="form-control"
              />
              <button type="button" (click)="finDatepicker.toggle()" class="btn btn-outline-secondary">
                <fa-icon icon="calendar-alt"></fa-icon>
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</form>

    <table class="table table-striped" aria-label="Liste des historiques de suivi parcellaire viticole" *ngIf="historiques?.length > 0; else aucunHistorique">
      <thead>
        <tr>
          <th class="liste-col-header"  translate>page.declarations.suivi-parcellaires-viticoles.table.header.raisonSociale
          </th>
          <th class="liste-col-header"  translate>page.declarations.suivi-parcellaires-viticoles.table.header.commune</th>
          <th class="liste-col-header"  translate>page.declarations.suivi-parcellaires-viticoles.table.header.referenceCadastrale</th>
          <th class="liste-col-header"  translate>page.declarations.suivi-parcellaires-viticoles.table.header.produit</th>
          <th class="liste-col-header"  translate>page.declarations.suivi-parcellaires-viticoles.table.header.anneePlantation</th>
          <th class="liste-col-header"  translate>page.declarations.suivi-parcellaires-viticoles.table.header.variete</th>
          <th class="liste-col-header"  translate>page.declarations.suivi-parcellaires-viticoles.table.header.surfacePlantee</th>
          <th class="liste-col-header"  translate>page.declarations.suivi-parcellaires-viticoles.table.header.surfaceEngagee</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let historique of historiques">
          <td>{{ historique.entreprise?.raisonSociale }}</td>
          <td>{{ historique.commune }}</td>
          <td>{{ historique.referenceCadastrale }}</td>
          <td>{{ historique.libelleProduit }}</td>
          <td>{{ historique.anneePlantation }}</td>
          <td>{{ historique.variete }}</td>
          <td>{{ historique.surfacePlantee }}</td>
          <td>{{ historique.surfaceEngagee }}</td>
          <td style="text-align:center">
            <div >
                <h4  (click)="onEdit(historique)">
                  <fa-icon icon="info-circle"></fa-icon>
                </h4>
              </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Template aucun historique -->
<ng-template #aucunHistorique>
  <div class="alert alert-warning alert-block" translate>
    <fa-icon icon="exclamation"></fa-icon> page.declarations.suivi-parcellaires-viticoles.aucunHistorique
  </div>
</ng-template>
<!-- Fin template aucun historique -->
